exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-e-menu-tooltip-v5:after,\n.w-e-menu-tooltip-v5:before {\n  display: none;\n}", ""]);

// exports
